import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { Route, Redirect } from 'react-router-dom';
import config from 'config';
import { PrivateRoute, ErrorBoundary } from './components';
import { useDarkstoreContext } from './contexts/Darkstore';
import {
  Account,
  Catalog,
  Checkout,
  LegalInformation,
  Login,
  Main,
  MobileApp,
  NotFound,
  PaymentResult,
  Product,
  Registration,
  TechnicalBreak,
} from './features';
import { useScrollToTop } from './hooks';

const App = () => {
  useScrollToTop();

  const { t } = useTranslation();
  const { darkstore } = useDarkstoreContext();

  return (
    <ErrorBoundary>
      <Helmet>
        <title>
          {t('meta:index.title', { siteName: config.SITE_NAME, cityName: darkstore.city })}
        </title>
        <meta
          name="title"
          content={t('meta:index.title', { siteName: config.SITE_NAME, cityName: darkstore.city })}
        />
        <meta
          name="description"
          content={t('meta:index.description', {
            siteName: config.SITE_NAME,
            cityName: darkstore.city,
          })}
        />
      </Helmet>
      <Main>
        <Route path="/mobile-app" component={MobileApp} />
        <Route path="/login" component={Login} />
        <Route path={['/legal', '/rules', '/payment-rules']} component={LegalInformation} />
        <Route path="/products/:productSlug" component={Product} />
        <Route path="/registration" component={Registration} />
        <Route path="/technical-break" component={TechnicalBreak} />
        <Route path="/payment-result" component={PaymentResult} />
        <PrivateRoute path="/account" component={Account} />
        <PrivateRoute path="/checkout" component={Checkout} />

        <Route exact path="/" component={Catalog} />
        <Route
          path={['/categories', '/search', '/brands', '/favorites', '/catalog', '/special']}
          component={Catalog}
        />

        <Route path="/not-found" component={NotFound} />
        <Route path="/404" component={NotFound} />
      </Main>
    </ErrorBoundary>
  );
};

export default App;
